import script from "./DemandAdstxtReport.vue?vue&type=script&setup=true&lang=js"
export * from "./DemandAdstxtReport.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__